// Translations
import form from '../sections/form/translations/ar'

// Translation: Register > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
